/**
 * Application Configuration
 * Centralized configuration for the application
 */

export const APP_CONFIG = {
  // Email domain restriction
  ALLOWED_EMAIL_DOMAIN: 'gohighlevel.com',
  
  // App name
  APP_NAME: 'Kaizen Platform',
  
  // API settings
  API_TIMEOUT: 30000, // 30 seconds
  
  // Pagination
  DEFAULT_PAGE_SIZE: 20,
  MAX_PAGE_SIZE: 100,
  
  // File upload
  MAX_FILE_SIZE: 10 * 1024 * 1024, // 10MB
  ALLOWED_FILE_TYPES: ['image/jpeg', 'image/png', 'image/gif', 'application/pdf'],
  
  // Toast notifications
  TOAST_DURATION: {
    SUCCESS: 3000,
    ERROR: 5000,
    WARNING: 4000,
    INFO: 3000
  }
}

/**
 * Validate if an email belongs to the allowed domain
 * @param {string} email - Email address to validate
 * @returns {boolean} - True if email is from allowed domain
 */
export function isValidEmailDomain(email) {
  if (!email || typeof email !== 'string') return false
  
  const domain = email.split('@')[1]
  return domain?.toLowerCase() === APP_CONFIG.ALLOWED_EMAIL_DOMAIN.toLowerCase()
}

/**
 * Get a user-friendly error message for invalid email domain
 * @returns {string} - Error message
 */
export function getInvalidDomainMessage() {
  return `Only email addresses from @${APP_CONFIG.ALLOWED_EMAIL_DOMAIN} are allowed`
}

